<template>
  <div class="overall-bg pb-0">
    <b-container>
      <b-row>
        <b-col>
          <BackToMasters :goback="$router.back"></BackToMasters>
          <Headerlayout
            :headertext="$t('Quotes.title')"
            :contenttext="$t('Quotes.contents')"
          ></Headerlayout>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <!-- {{ dataItems }}add -->

  <div class="overall-bg pt-0">
    <b-container>
      <div class="form-white-bg">
        <b-form>
          <b-row>
            <b-col lg=" 3" md="4" sm="6">
              <div class="field">
                <label>{{ Codes.Label }}</label>
                <!-- <TextInput name="QuoteID" :label="Codes.Label" :rules="{ required: false }" :disabled="true"
                  v-model="ObjVal.DocNo" :required-icon="false" /> -->
                {{ ObjVal.DocNo }}
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6" v-if="QueryStringType == '1'">
              <div class="field">
                <TextInput
                  :label="CodesRef.Label"
                  :required-icon="false"
                  name="RefCode"
                  id="RefCode"
                  :disabled="true"
                  v-model="ObjVal.RefNo"
                  :rules="{ required: false, alphabet: false }"
                />
              </div>
            </b-col>
            <b-col lg="3" md="4" sm="6">
              <div class="field">
                <CustomDropdown
                  id="Supplier"
                  name="Supplier"
                  :label="$t('5005.choosesupppier')"
                  :rules="{ required: true }"
                  :items="LoadSupplierOptions.SupplierOption"
                  v-model="ObjVal.SupplierId"
                  :required-icon="true"
                  @update:modelValue="GetSupplierData"
                  :commonItemProps="commonItemProps"
                  :disabled="SupplierDropDownDisable"
                />
              </div>
            </b-col>
            <b-col lg="5" md="4" sm="6" cols="12" class="d-flex">
              <div class="field">
                <label>{{ $t("Request.uploadquotation") }}</label>
                <input
                  type="file"
                  :multiple="true"
                  id="actual-btn"
                  @change="handleChangedocument"
                  ref="fileInput"
                  style="display: none"
                />
                <label id="custom-btn" for="actual-btn" class="flbtn">
                  <i class="pi pi-upload" style="color: slateblue"></i>
                  Choose File</label
                >
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              lg="3"
              md="4"
              sm="6"
              cols="12"
              class="d-flex"
              v-for="item in uploadedTableList"
            >
              <div class="fileuploadcard my-2" :title="item.fileName">
                <div>
                  <p class="filenametxt">{{ item.fileName }}</p>
                  <div
                    class="blue-txt"
                    id="file-name"
                    @click="fileviewer(item.fullPath)"
                  >
                    view
                  </div>
                </div>
                <DeleteIcon @click="fileuploadDelete(item)" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <Item
              @additemclick="AddItems"
              :show-fields="showFields"
              v-model:data-items="dataItems"
              :addItemData="items"
              :isFilterData="itemDatas"
              :commonItemProps="commonItemProps"
            />
          </b-row>
          <b-row>
            <Tableview
              :rowHover="true"
              filterDisplay="menu"
              responsiveLayout="scroll"
              :columns="headers"
              :globalFilterFields="globalFilterFields"
              v-model:value="items"
              :serialNumber="true"
            >
              <template v-slot:Add>
                <span>
                  <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                </span>
              </template>
              <template v-slot:action="{ data }">
                <div class="d-flex align-items-center">
                  <EditIcon @click="IsItemEdit(data)" />
                  <DeleteIcon @click="IsItemDelete(data)" />
                </div>
              </template>
            </Tableview>
            <Footer class="py-3" :goback="$router.back" @save="IsSubmit()" />
          </b-row>
        </b-form>
      </div>
    </b-container>
  </div>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <Toast />
</template>

<script lang="ts">
import BackToMasters from "../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import { defineComponent, ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Footer from "../../../../components/FormComponents/Footer.vue";
import Item from "../../../../modules/Inventory/components/Transaction/Item.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import Dropdown from "../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import common from "../../../Inventory/Service/CommonService";
import Tableview from "../../../../components/FormComponents/NormalTable.vue";
import WithoutStockService from "../../../Inventory/Service/WithoutStockAffectService";
import SupplierService from "../../../../../src/modules/Inventory/Service/SupplierMaster";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import CreateSuccessully from "../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../components/FormComponents/UpdatedSuccessfully.vue";
import WithoutStockAffectService from "../../../Inventory/Service/WithoutStockAffectService";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import { useI18n } from "vue-i18n";
import { useForm } from "vee-validate";
import { setupHistoryManagement } from "../../../../modules/Inventory/Service/HistoryManage";
import StockWOFileUploadServices from "../../../../modules/Inventory/Service/StockWOFileUploadService";

export default defineComponent({
  components: {
    Footer,
    BackToMasters,
    Headerlayout,
    TextInput,
    Datepicker,
    Dropdown,
    Tableview,
    Item,
    CustomDropdown,
    CreateSuccessully,
    UpdatedSuccessfully,
  },

  props: {},

  setup() {
    debugger;
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    const route = useRoute();
    const router = useRouter();
    let items: any = ref([]);
    let dupitems: any = ref([]);

    const successpop = ref(false);
    const updatepop = ref(false);
    let getCodeFormId = ref(0);
    const toast = useToast();
    let SupplierDropDownDisable = ref(false);

    let fullPath = ref();
    let uploadedTableList: any = ref([]);
    let DeletedFileUpload: any = [];
    const StockWOFileUpload = ref([]);

    onMounted(() => {
      debugger;
      PageRadyFunction();
    });

    const commonItemProps = ref({
      storeId: "",
      type: 0,
      supplierId: 0,
      itemType: 2,
    });
    const itemDatas = ref([]);
    let QueryStringValue3: any = route.query;
    QueryStringValue3 = JSON.parse(QueryStringValue3.data);
    let StoreID = QueryStringValue3["StoreId"];
    let StoreMapID = QueryStringValue3["StoreBrMapId"];
    let queryBranchId = QueryStringValue3["BranchId"];
    let IsDraftFlag = QueryStringValue3["IsDraft"];

    let StockWoTransTMId = QueryStringValue3["StockWoTransTMId"];
    let QueryStringType = QueryStringValue3["type"];
    commonItemProps.value.storeId = QueryStringValue3["StoreId"];
    let OperationId = Number(QueryStringValue3.OperationId) ?? 0;
    let Entitydata = ref();
    //Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = Number(QueryStringValue3.EntityId) ?? 0;
    const Codes = ref({
      Label: "",
    });
    const CodesRef = ref({
      Label: "",
    });

    const { t } = useI18n();
    const label = ref(t("btn.save"));
    async function PageRadyFunction() {
      debugger;
      if (QueryStringType == "1") {
        Codes.value.Label = t("Quotes.amendmentcode");
        CodesRef.value.Label = t("Quotes.code");
        getCodeFormId.value = 1031;
        if (StockWoTransTMId != "0" && QueryStringType != "1") {
          await GetDataByQuotId(StockWoTransTMId);
        } else {
          await GetCode();
          await GetDataByQuotId(StockWoTransTMId);
        }
      } else if (QueryStringType == "0") {
        Codes.value.Label = t("Quotes.code");
        CodesRef.value.Label = t("Quotes.amendmentcode");
        getCodeFormId.value = 1025;

        if (StockWoTransTMId != "0") {
          await GetDataByQuotId(StockWoTransTMId);
        } else {
          await GetCode();
        }
      }

      await LoadPIid();
      await LoadSuppliers();
    }

    async function GetDataByQuotId(StockWoTransTMId) {
      debugger;
      let result = await WithoutStockAffectService.GetByStockWOTransId(
        StockWoTransTMId
      );
      console.log(result);
      let data = result["result"];
      ObjVal.value.RefId = data[0]["StockWOTransId"];
      ObjVal.value.SupplierId = data[0]["SupplierId"];
      commonItemProps.value.supplierId = data[0]["SupplierId"];
      Object.keys(ObjVal.value).forEach((key) => {
        if (StockWoTransTMId != "0" && route.query.param == "Quotes") {
          if (key == "RefNo" && (data[0][key] == "" || data[0][key] == null)) {
          }
          if (data[0][key]) ObjVal.value[key] = data[0][key];
        } else if (
          StockWoTransTMId != "0" &&
          route.query.param == "QuoteAmendment"
        ) {
          if (key == "DocNo") {
            ObjVal.value.RefNo = data[0][key];
          } else {
            if (key != "RefNo") {
              if (data[0][key]) ObjVal.value[key] = data[0][key];
            }
          }
        }
      });
      const FileUploadresult =
        await StockWOFileUploadServices.getStockWOFileById(StockWoTransTMId);
      if (FileUploadresult["result"].length > 0) {
        for (let i = 0; i < FileUploadresult["result"].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] =
            FileUploadresult["result"][i].FileName.split("/FileUpload/")[1]),
            (Fileobj["fileName"] =
              FileUploadresult["result"][i].FileName.split("/").pop()),
            (Fileobj["fileType"] = Fileobj["url"].split("/")[0]),
            (Fileobj["fullPath"] = FileUploadresult["result"][i].FileName),
            (Fileobj["Id"] = FileUploadresult["result"][i].Id),
            uploadedTableList.value.push(Fileobj);
        }
      }
      SupplierDropDownDisable.value = true;
      items.value = data.map((obj) => ({
        ...obj,
        MRP: obj.MRP.toFixed(2),
      }));
    }

    // For Get Current date and time in sql server format
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();

    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds
      .toString()
      .padStart(3, "0")}`;
    // end

    let ObjVal = ref({
      Id: 0,
      DocType: "",
      DocNo: "",
      RefId: 0,
      RefNo: "",
      SupplierId: ref(),
      DocDate: formattedDate,

      StoreBrMapId: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      StoreId: 0,
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      IsDraft: 0,
      StockWODetailList: [],
    });

    const grossvalues = ref({
      grossamount: 0.0,
      taxamount: 0.0,
      totaldiscountamount: 0.0,
      transportcharges: 0.0,
      servicecharges: 0.0,
      othercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
    });

    // show fields for item component
    // let showFields = {
    //   Supplier: false,
    //   Category: true,
    //   Name: true,
    //   Batch: false,
    //   PackSize: true,
    //   UnitRate: true,
    //   Qty: true,
    //   MRP: true,
    //   Discount: false,
    // };
    let showFields = {
      // Category: true,
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: false,
        require: false,
      },
      PackSize: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      MRP: {
        show: true,
        require: false,
      },
      Discount: {
        show: false,
        require: false,
      },
      AvailQty: {
        show: false,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
      UOM: {
        show: true,
        require: true,
      },
    };

    async function GetCode() {
      debugger;
      // alert(9)
      let data = {
        // FormId: getCodeFormId.value,
        EntityId: Entitydata.value,
        HospitalId: HospitalId,
        BranchId: queryBranchId,
        StoreId: StoreID ?? 0,
      };
      let result: any = await common.getCodeTemplate(data);
      ObjVal.value.DocNo = result;
    }

    const headers = [
      {
        header: t("storetabdetails.quotescreate.Category"),
        field: "ItemCategory1",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotescreate.Code"),
        field: "ItemProductId",
        class: "smallwidth",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: t("storetabdetails.quotescreate.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.quotescreate.AvlQty"),
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotescreate.Reorderlevel"),
        field: "ReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotescreate.RequiredQty"),
        field: "RequiredQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotescreate.ReqQty"),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.quotescreate.MRP"),
        field: "MRP",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Choose Supplier",
      //   field: "SupplierId",
      // },
      // {
      //   header: "Per Unit Landing Cost",
      //   field: "",

      //   bodyclass: "right_td",
      //   class: "smallwidth",
      // },
      // {
      //   header: "Payment Terms",
      //   field: "",
      // },
      // {
      //   header: "Delivery Terms",
      //   field: "",
      // },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,

        class: "last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    // const AddItems = (value) => {
    //   debugger;
    //   console.log(value);
    //   items.value = value;
    // };

    // //Load Items by StockWoTrans Id
    // async function IsShowByStockTransId(StockTransTMId) {
    //   debugger;
    //   const result = await WithoutStockService.GetByStockWOTransId(
    //     StockTransTMId
    //   );
    //   console.log(result["result"]);
    //   items.value = result["result"];
    // }

    const dataItems = ref({});
    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
    }

    //Item Delete
    async function IsItemDelete(data) {
      debugger;
      let msg = null;
      if (data["StockDetailsId"]) {
        const result = await WithoutStockService.deleteStockWoDetails(
          data["StockDetailsId"]
        );
        msg = result["ErrorInfo"].ErrorCode;
      }
      if (msg == null) {
        items.value = items.value.filter(
          (item) => item["ItemId"] != data.ItemId
        );
      }
    }

    function TotalGrossCalc(value1) {
      debugger;
      grossvalues.value.grossamount = value1.grossamount;
      grossvalues.value.totalqty = value1.totalqty;
      grossvalues.value.taxamount = value1.taxamount;
      grossvalues.value.totaldiscountamount = value1.totaldiscountamount;
      grossvalues.value.othercharges = value1.totalothercharges;
      grossvalues.value.transportcharges = value1.totaltransportcharges;
      grossvalues.value.servicecharges = value1.totalservicecharges;
      grossvalues.value.netamount = value1.netamount;
    }
    const { handleSubmit, errors, resetForm, resetField } = useForm();

    //Quotes Creation
    var arr: any = [];

    const IsSubmit = handleSubmit(async (values) => {
      let response: any;
      let message = "";
      var FileUploadArray: any = [];
      let id: any;
      let quoteid: any;
      debugger;
      if (ObjVal.value.SupplierId == null) {
        toast.add({
          severity: "warn",
          summary: "Choose the Supplier",
          detail: "",
          life: 3000,
        });
        return;
      } else if (items.value.length == 0) {
        toast.add({
          severity: "warn",
          summary: "Add the Items",
          detail: "",
          life: 3000,
        });
        return;
      } else {
        ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        if (StockWoTransTMId != 0) {
          quoteid = StockWoTransTMId;
        } else {
          quoteid = ObjVal.value.Id;
        }
        if (QueryStringType == "1") {
          ObjVal.value.DocType = "16";
        } else {
          ObjVal.value.DocType = "3";
        }
        ObjVal.value.StoreId = StoreID;
        ObjVal.value.StoreBrMapId = StoreMapID;

        ObjVal.value.Id = quoteid;
        ObjVal.value.Amount = grossvalues.value.grossamount;
        ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.BranchId = queryBranchId;
        ObjVal.value.HospitalId = HospitalId;
        ObjVal.value.ModifiedBy = UserId;
        ObjVal.value.CreatedBy = UserId;
        ObjVal.value.EntityId = Number(Entitydata.value);
        ObjVal.value.EntityOperationId = OperationId;
        ObjVal.value.IsDraft = 0;
        debugger;
        let LineItems: any = items.value;
        for (let i = 0; i < LineItems.length; i++) {
          let obj = {};
          let stockdetailID = 0;
          if (QueryStringType == "0") {
            stockdetailID = LineItems[i]["StockDetailsId"];
          }

          (obj["Id"] = stockdetailID),
            (obj["ItemId"] = LineItems[i]["ItemId"]),
            (obj["Qty"] = LineItems[i]["ItemQuantity"]),
            (obj["RefId"] = quoteid),
            (obj["PackSizeId"] = LineItems[i]["PackSizeId"]),
            (obj["HSNId"] = LineItems[i]["HSNId"]),
            (obj["CreatedAt"] = "2023-03-15T13:40:56.139Z");
          (obj["Rate"] = LineItems[i]["Rate"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),
            (obj["UnitRate"] = LineItems[i]["UnitRate"]),
            (obj["MRP"] = LineItems[i]["MRP"]),
            (obj["UOM"] = LineItems[i]["UOM"]),
            (arr[i] = obj);
        }
        ObjVal.value.StockWODetailList = arr;
        let result = await WithoutStockService.createStockWODraft(ObjVal.value);
        id = result["result"][0].Id;
        ObjVal.value.Id = id;
        for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
          const ResultList = result["result"][0];
          items.value[items.value.length - 1].Id =
            ResultList.StockWODetailList[0]["Id"];
          items.value[items.value.length - 1].StockDetailsId =
            ResultList.StockWODetailList[0]["Id"];
        }
        if (uploadedTableList.value.length != 0) {
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            let Fileobj = {};
            (Fileobj["Id"] = uploadedTableList.value[i].Id),
              (Fileobj["DocType"] = ObjVal.value.DocType),
              (Fileobj["RefId"] = ObjVal.value.Id),
              (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
              (Fileobj["CreatedAt"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (Fileobj["CreatedBy"] = UserId),
              (Fileobj["ModifiedBy"] = 0),
              (Fileobj["EntityId"] = Number(Entitydata.value)),
              (Fileobj["IsApproved"] = 0),
              FileUploadArray.push(Fileobj);
          }
          StockWOFileUpload.value = FileUploadArray;
          let FileUploadResult =
            await StockWOFileUploadServices.insertStockWOFile(
              StockWOFileUpload.value
            );
        }
        if (DeletedFileUpload.length > 0) {
          debugger;
          let result = await StockWOFileUploadServices.DeleteList(
            DeletedFileUpload.join(",")
          );
        }
        let msgMapping = result["ErrorInfo"].ErrorCode;
        if (id != "0") {
          updatepop.value = true;
        } else {
          successpop.value = true;
        }
      }
    });

    // Load pi id for dropdown
    const Piid = ref({
      PiOptions: [],
      PIvalue: "",
    });

    async function LoadPIid() {
      debugger;
      const result = await WithoutStockService.GetPIList();
      Piid.value.PiOptions = result["result"]
        .map((item) => {
          item.name = item.DocNo;
          item.value = item.Id;
          return item;
        })
        .filter((item) => item.DocType == 2);
    }

    // cont value = Piid.value.PiOptions
    async function PiidOnchange(piid) {
      const result = await WithoutStockService.GetPIItemList(piid);
      items.value = result["result"];
    }

    // Load Suppliers
    const LoadSupplierOptions = ref({
      SupplierOption: [],
    });

    async function LoadSuppliers() {
      debugger;
      const result = await SupplierService.GetSuppliersByStoreId(
        StoreID ?? 0,
        queryBranchId
      );
      LoadSupplierOptions.value.SupplierOption = result["result"]
        .filter((f) => f.IsActive == true)
        .map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      setupHistoryManagement(router, 2);
    }

    function GetSupplierData(SupplierId) {
      commonItemProps.value.supplierId = SupplierId;
    }
    ///
    const IsSubmitDraft = handleSubmit(async (values) => {
      debugger;
      let response: any;
      var FileUploadArray: any = [];
      let message = "";
      let id: any;
      let quoteid: any;
      debugger;
      if (items.value.length > 0) {
        ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        if (StockWoTransTMId != 0) {
          quoteid = StockWoTransTMId;
        } else {
          quoteid = ObjVal.value.Id;
        }
        ObjVal.value.IsDraft = 1;
        if (QueryStringType == "1") {
          ObjVal.value.DocType = "16";
        } else {
          ObjVal.value.DocType = "3";
        }
        ObjVal.value.Id = quoteid;
        ObjVal.value.StoreId = StoreID;
        ObjVal.value.StoreBrMapId = StoreMapID;
        ObjVal.value.Amount = grossvalues.value.grossamount;
        ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.BranchId = queryBranchId;
        ObjVal.value.HospitalId = HospitalId;
        ObjVal.value.ModifiedBy = UserId;
        ObjVal.value.CreatedBy = UserId;
        ObjVal.value.EntityId = Number(Entitydata.value);
        ObjVal.value.EntityOperationId = OperationId;
        //
        debugger;
        for (let i = 0; i < dupitems.value.length; i++) {
          let obj = {};
          (obj["Id"] = dupitems.value[i]["StockDetailsId"]),
            (obj["ItemId"] = dupitems.value[i]["ItemId"]),
            (obj["Qty"] = dupitems.value[i]["ItemQuantity"]),
            (obj["RefId"] = quoteid),
            (obj["PackSizeId"] = dupitems.value[i]["PackSizeId"]),
            (obj["HSNId"] = dupitems.value[i]["HSNId"]),
            (obj["CreatedAt"] = "2023-03-15T13:40:56.139Z");
          (obj["Rate"] = dupitems.value[i]["Rate"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),
            (obj["UnitRate"] = dupitems.value[i]["UnitRate"]),
            (obj["MRP"] = dupitems.value[i]["MRP"]),
            (obj["UOM"] = dupitems.value[i]["UOM"]),
            (arr[i] = obj);
          arr[i] = obj;
        }
        ObjVal.value.StockWODetailList = arr;
        let result = await WithoutStockService.createStockWODraft(ObjVal.value);
        id = result["result"][0].Id;
        ObjVal.value.Id = id;
        for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
          const ResultList = result["result"][0];
          items.value[items.value.length - 1].Id =
            ResultList.StockWODetailList[0]["Id"];
          items.value[items.value.length - 1].StockDetailsId =
            ResultList.StockWODetailList[0]["Id"];
        }
        if (uploadedTableList.value.length != 0) {
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            let Fileobj = {};
            (Fileobj["Id"] = uploadedTableList.value[i].Id),
              (Fileobj["DocType"] = ObjVal.value.DocType),
              (Fileobj["RefId"] = ObjVal.value.Id),
              (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
              (Fileobj["CreatedAt"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (Fileobj["CreatedBy"] = UserId),
              (Fileobj["ModifiedBy"] = 0),
              (Fileobj["EntityId"] = Number(Entitydata.value)),
              (Fileobj["IsApproved"] = 0),
              FileUploadArray.push(Fileobj);
          }
          StockWOFileUpload.value = FileUploadArray;
          let FileUploadResult =
            await StockWOFileUploadServices.insertStockWOFile(
              StockWOFileUpload.value
            );
          debugger;
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            uploadedTableList.value[i].Id = FileUploadResult["result"][i]["Id"];
          }
        }
        // loading.value = false
      } else {
        toast.add({
          severity: "warn",
          summary: "Please Add the Item",
          detail: "",
          life: 3000,
        });
      }
    });
    const AddItems = async (value) => {
      debugger;
      console.log(value);
      dupitems.value = [];
      items.value = await value;
      const lastIndex = Number(items.value.length - 1);
      dupitems.value.push(items.value[lastIndex]);
      await IsSubmitDraft();
    };
    const handleChangedocument = async (event: Event) => {
      debugger;
      debugger;
      let result;
      let files: any = "";
      const input = event.target as HTMLInputElement;
      files = input["files"];
      console.log(files);
      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, "TransactionFiles");
          console.log("Uploaded :", result);
          let ResponseValue = result;
          ResponseValue["Id"] = 0;
          fullPath.value = result.uploadPath;
          uploadedTableList.value.push(ResponseValue);
        }
      }
      debugger;
      console.log(uploadedTableList.value);
    };
    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }
    const fileuploadDelete = async (data) => {
      DeletedFileUpload.push(data.Id);
      uploadedTableList.value = uploadedTableList.value.filter(
        (item) => item.fileName != data.fileName
      );
      if (DeletedFileUpload.length > 0 && IsDraftFlag == 1) {
        debugger;
        let result = await StockWOFileUploadServices.DeleteList(
          DeletedFileUpload.join(",")
        );
      }
    };
    return {
      itemDatas,
      items,
      GetCode,
      ObjVal,
      globalFilterFields,
      headers,
      AddItems,
      showFields,
      LoadPIid,
      Piid,
      PiidOnchange,
      LoadSuppliers,
      LoadSupplierOptions,
      commonItemProps,
      dataItems,
      IsSubmit,
      IsItemEdit,
      IsItemDelete,
      closetrigger,
      successpop,
      updatepop,
      Codes,
      CodesRef,
      QueryStringType,
      TotalGrossCalc,
      GetSupplierData,
      SupplierDropDownDisable,
      handleChangedocument,
      uploadedTableList,
      fileviewer,
      fileuploadDelete,
    };
  },
  created() {},
});
</script>
